module.exports = __webpack_public_path__ + "img/Nic Munoz-McDonald.012276ae.jpg";